// extracted by mini-css-extract-plugin
module.exports = {"content":"deal-sync-sidebar-modal_content__rdGQf","image":"deal-sync-sidebar-modal_image__vGIAm"};